import { ModalCustom } from "components/ModalCustom";
import { IResultadoPagamento } from "../../interfaces/IDebitoIpva";
import { TabelaResultados } from "./style";

interface IProps {
  show: boolean;
  handleClose: () => void;
  resultados: IResultadoPagamento[];
}

export function ModalResultadoPagamento({ show, handleClose, resultados }: IProps) {
  const sucessos = resultados.filter((r) => !r.erro);
  const erros = resultados.filter((r) => r.erro);

  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Resultado do Pagamento"
      size="lg"
      footer
      footerCloseButton
    >
      <TabelaResultados>
        <thead>
          <tr>
            <th>ID Processo</th>
            <th>Exercício</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {sucessos.map((item) => (
            <tr key={`${item.id}_${item.exercicio}_ok`}>
              <td>{item.id}</td>
              <td>{item.exercicio}</td>
              <td style={{ color: "#28a745" }}>Pagamento realizado com sucesso</td>
            </tr>
          ))}
          {erros.map((item) => (
            <tr key={`${item.id}_${item.exercicio}_err`}>
              <td>{item.id}</td>
              <td>{item.exercicio}</td>
              <td style={{ color: "#dc3545" }}>Erro: {item.mensagem}</td>
            </tr>
          ))}
        </tbody>
      </TabelaResultados>
    </ModalCustom>
  );
}
